"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DotsVertical = void 0;
/* eslint-disable import/prefer-default-export */
var react_1 = __importDefault(require("react"));
var DotsVertical = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '24px' : _b, _c = _a.color, color = _c === void 0 ? 'currentColor' : _c;
    return react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("circle", { cx: "12", cy: "6", r: "2", transform: "rotate(90 12 6)", fill: color }),
        react_1.default.createElement("circle", { cx: "12", cy: "12", r: "2", transform: "rotate(90 12 12)", fill: color }),
        react_1.default.createElement("circle", { cx: "12", cy: "18", r: "2", transform: "rotate(90 12 18)", fill: color }));
};
exports.DotsVertical = DotsVertical;
